(function() {
  if (window.startWithASet && window.startWithASet._booted) {
    document.dispatchEvent(new CustomEvent('startWithASetReady'));
    return;
  }
  var SWS_MODAL_VAR_NAMES = [
    '--sws-modal-bg',
    '--sws-modal-text',
    '--sws-modal-muted',
    '--sws-modal-border',
    '--sws-modal-cta-bg',
    '--sws-modal-cta-text',
    '--sws-modal-swatch-border',
    '--sws-add-text'
  ];
  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function formatMoney(cents) {
    if (window.$s && typeof window.$s.formatMoney === 'function') {
      return window.$s.formatMoney(cents);
    }
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '$');
    }
    return (cents / 100).toFixed(2);
  }
  function parseDiscountPercentage(data) {
    if (!data || data.discountPercentage == null) return null;
    var n = Number(data.discountPercentage);
    if (!isFinite(n) || n <= 0 || n > 100) return null;
    return n;
  }
  function applyDiscountCents(cents, discountPct) {
    return Math.round(cents * (1 - discountPct / 100));
  }
  function replacePercentageToken(template, discountPct) {
    return String(template || '').replace(/%percentage%/g, String(discountPct));
  }
  var SWS_MODAL_VAR_DEFAULTS = {
    '--sws-modal-bg': '#ffffff',
    '--sws-modal-text': '#2a2727',
    '--sws-modal-muted': '#666666',
    '--sws-modal-border': '#ece8e8',
    '--sws-modal-cta-bg': '#7e0128',
    '--sws-modal-cta-text': '#ffffff',
    '--sws-modal-swatch-border': '#000000',
    '--sws-add-text': '#7e0128'
  };
  function copySwsModalVarsFromSectionToNode(targetEl, sectionRoot) {
    if (!targetEl) return;
    var cs = sectionRoot && window.getComputedStyle ? window.getComputedStyle(sectionRoot) : null;
    SWS_MODAL_VAR_NAMES.forEach(function(name) {
      var v = cs ? cs.getPropertyValue(name) : '';
      if (!v || String(v).trim() === '') v = SWS_MODAL_VAR_DEFAULTS[name] || '';
      if (v && String(v).trim() !== '') {
        targetEl.style.setProperty(name, String(v).trim());
      }
    });
  }
  function buildVariantImageHtml(product, variant) {
    var imgObj = variant && variant.featured_image ? variant.featured_image : null;
    if (!imgObj && product && product.featured_image) imgObj = product.featured_image;
    var src = imgObj && (imgObj.src || (imgObj.preview_image && imgObj.preview_image.src));
    if (!src) return '<div class="bundle-item-image-wrap"></div>';
    return '<img class="img main" src="' + escapeAttr(src) + '" width="63" height="80" alt="" loading="lazy" />';
  }
  function getModalLineVariantId(lineEl) {
    var atc = lineEl.querySelector('product-card-atc.start-with-set-modal-atc');
    if (!atc) return null;
    var inp = atc.querySelector('input.single-option-selector[name="id"]') || atc.querySelector('input[data-variant-id]');
    if (!inp || !inp.value) return null;
    return inp.value / 1;
  }
  function getLineProductJson(lineEl, data) {
    var pid = lineEl.dataset.productId;
    var line = data.lines.find(function(l) { return String(l.product.id) === String(pid); });
    return line ? line.product : null;
  }
  function modalLineRow(card, line) {
    var wrap = document.createElement('div');
    wrap.className = 'start-with-set-modal-line';
    wrap.dataset.productId = String(line.product.id);
    var row = document.createElement('div');
    row.className = 'start-with-set-modal-line__row';
    var thumb = document.createElement('div');
    thumb.className = 'start-with-set-modal-line__thumb';
    if (line.thumbUrl) {
      var im = document.createElement('img');
      im.src = line.thumbUrl;
      im.width = line.thumbWidth || 160;
      im.height = line.thumbHeight || 160;
      im.alt = '';
      thumb.appendChild(im);
    }
    var body = document.createElement('div');
    body.className = 'start-with-set-modal-line__body';
    var name = document.createElement('p');
    name.className = 'start-with-set-modal-line__name';
    name.textContent = line.product.title || '';
    var subEl = document.createElement('p');
    subEl.className = 'start-with-set-modal-line__sub';
    subEl.textContent = line.subtitle || '';
    var picker = document.createElement('div');
    picker.className = 'start-with-set-modal-line__picker';
    var tpl = card.querySelector('template[data-sws-line-template-id="' + String(line.product.id) + '"]');
    if (tpl && tpl.content) {
      picker.appendChild(tpl.content.cloneNode(true));
    }
    body.appendChild(name);
    body.appendChild(subEl);
    body.appendChild(picker);
    row.appendChild(thumb);
    row.appendChild(body);
    wrap.appendChild(row);
    return wrap;
  }
  function sumSelectedCents(linesRoot, data) {
    var total = 0;
    linesRoot.querySelectorAll('.start-with-set-modal-line').forEach(function(lineEl) {
      var vid = getModalLineVariantId(lineEl);
      var product = getLineProductJson(lineEl, data);
      if (!product || !product.variants || vid == null) return;
      var v = product.variants.find(function(x) { return Number(x.id) === Number(vid); });
      if (v && v.price) total += v.price;
    });
    return total;
  }
  function productHasAnyAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return false;
    return product.variants.some(function(v) { return !!v.available; });
  }
  function anyLineSoldOut(linesRoot, data) {
    var soldOut = false;
    linesRoot.querySelectorAll('.start-with-set-modal-line').forEach(function(lineEl) {
      if (soldOut) return;
      var product = getLineProductJson(lineEl, data);
      if (!productHasAnyAvailableVariant(product)) soldOut = true;
    });
    return soldOut;
  }
  function updateSubmitLabel(btn, linesRoot, data) {
    var hasSoldOutLine = anyLineSoldOut(linesRoot, data);
    btn.disabled = hasSoldOutLine;
    var cents = sumSelectedCents(linesRoot, data);
    var base = (window.lngg && window.lngg.start_with_a_set_add_to_bundle_cta) ? window.lngg.start_with_a_set_add_to_bundle_cta : 'Add to bundle';
    var labelEl = btn.querySelector('.start-with-set-modal-inner__submit-label');
    var pricesEl = btn.querySelector('.start-with-set-modal-inner__submit-prices');
    var discountPct = parseDiscountPercentage(data);
    if (!labelEl || !pricesEl) return;
    labelEl.textContent = base + ' – ';
    if (discountPct && cents > 0) {
      var dealCents = applyDiscountCents(cents, discountPct);
      pricesEl.innerHTML = '<s class="start-with-set-modal-inner__submit-compare">' + formatMoney(cents) + '</s><span class="start-with-set-modal-inner__submit-deal">' + formatMoney(dealCents) + '</span>';
    } else {
      pricesEl.textContent = formatMoney(cents);
    }
  }
  function schedulePickerReady(cb) {
    requestAnimationFrame(function() {
      requestAnimationFrame(cb);
    });
  }
  function getSwsThemeRoot(card) {
    var swsSection = document.querySelector('[data-start-with-set-section]');
    if (swsSection) return swsSection;
    if (card && card.closest) {
      var fromCard = card.closest('[data-url-preset-set-root]');
      if (fromCard) return fromCard;
    }
    return document.querySelector('.bundle-builder-url-preset-sets') || document.querySelector('.bundle-builder-section');
  }
  function getSetCardJson(card) {
    if (!card) return null;
    var script = card.querySelector('script[type="application/json"][data-set-card-json]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (err) {
      return null;
    }
  }
  function findSetCardByPresetValue(presetValue) {
    var wanted = String(presetValue || '').trim();
    if (!wanted) return null;
    var presetRoot = null;
    document.querySelectorAll('[data-url-preset-value]').forEach(function(el) {
      if (presetRoot) return;
      if (String(el.getAttribute('data-url-preset-value') || '').trim() === wanted) presetRoot = el;
    });
    if (!presetRoot) return null;
    var card = presetRoot.querySelector('.start-with-set-card');
    return getSetCardJson(card) ? card : null;
  }
  function findSetCardByProductId(productId) {
    if (productId === undefined || productId === null || productId === '') return null;
    var cards = document.querySelectorAll('.start-with-set-card[data-product-id="' + String(productId) + '"]');
    var card = null;
    cards.forEach(function(el) {
      if (card) return;
      if (getSetCardJson(el)) card = el;
    });
    return card || cards[0] || null;
  }
  function findSetCardByHandle(handle) {
    if (!handle) return null;
    var wanted = String(handle).trim().toLowerCase();
    if (!wanted) return null;
    var card = null;
    document.querySelectorAll('.start-with-set-card[data-product-handle]').forEach(function(el) {
      if (card) return;
      var h = el.getAttribute('data-product-handle');
      if (h && String(h).trim().toLowerCase() === wanted && getSetCardJson(el)) card = el;
    });
    return card;
  }
  function getBundleSectionRoot(bb) {
    if (!bb || typeof bb.closest !== 'function') return null;
    return bb.closest('[id^="shopify-section-"]');
  }
  function syncStartWithSetUi(bb, items) {
    if (!bb) return;
    var bundleSection = getBundleSectionRoot(bb);
    document.querySelectorAll('[data-start-with-set-section] .start-with-set-card').forEach(function(card) {
      var pid = card.dataset.productId;
      var active = items.some(function(it) { return String(it.setOriginProductId || '') === String(pid); });
      card.classList.toggle('is-added', active);
      if (active) {
        var hint = (window.lngg && window.lngg.start_with_a_set_remove_set_hint) ? window.lngg.start_with_a_set_remove_set_hint : '';
        if (hint) card.setAttribute('title', hint);
      } else {
        card.removeAttribute('title');
      }
    });
    var titleEl = bundleSection ? bundleSection.querySelector('.bundle-builder-title') : null;
    if (!titleEl) return;
    if (typeof titleEl._swsDefaultBundleTitle === 'undefined') {
      var attr = titleEl.getAttribute('data-bundle-default-title');
      titleEl._swsDefaultBundleTitle = (attr !== null && attr !== '') ? attr : titleEl.textContent.trim();
    }
    var hasSet = items.some(function(it) { return it.setOriginProductId != null && String(it.setOriginProductId) !== ''; });
    var continueText = (window.lngg && window.lngg.start_with_a_set_continue_customize) ? window.lngg.start_with_a_set_continue_customize : 'Continue to customize';
    titleEl.textContent = hasSet ? continueText : titleEl._swsDefaultBundleTitle;
  }
  function openModal(root, card, data) {
    if (!data.lines || !data.lines.length) return false;
    if (!window.$s || typeof window.$s.openModal !== 'function') return false;
    var themeRoot = getSwsThemeRoot(card) || root;
    var inner = document.createElement('div');
    inner.className = 'start-with-set-modal-inner';
    copySwsModalVarsFromSectionToNode(inner, themeRoot);
    inner._swsData = data;
    var grid = document.createElement('div');
    grid.className = 'start-with-set-modal-inner__grid';
    var media = document.createElement('div');
    media.className = 'start-with-set-modal-inner__media';
    var mainImg = document.createElement('img');
    mainImg.src = data.parentImageUrl || '';
    mainImg.width = data.parentImageWidth || 800;
    mainImg.height = data.parentImageHeight || 800;
    mainImg.alt = data.parentTitle || '';
    media.appendChild(mainImg);
    var panel = document.createElement('div');
    panel.className = 'start-with-set-modal-inner__panel';
    var head = document.createElement('div');
    head.className = 'start-with-set-modal-inner__head';
    var h3 = document.createElement('h3');
    h3.className = 'start-with-set-modal-inner__title';
    h3.textContent = (window.lngg && window.lngg.start_with_a_set_modal_heading) ? window.lngg.start_with_a_set_modal_heading : 'Select shades';
    var sub = document.createElement('p');
    sub.className = 'start-with-set-modal-inner__subtitle';
    sub.textContent = data.parentTitle || '';
    head.appendChild(h3);
    head.appendChild(sub);
    var discountPct = parseDiscountPercentage(data);
    if (discountPct) {
      var badge = document.createElement('span');
      badge.className = 'start-with-set-modal-inner__discount-badge';
      var badgeTpl = (window.lngg && window.lngg.start_with_a_set_discount_badge) ? window.lngg.start_with_a_set_discount_badge : '%percentage% Off';
      badge.textContent = replacePercentageToken(badgeTpl, discountPct);
      head.appendChild(badge);
    }
    var lines = document.createElement('div');
    lines.className = 'start-with-set-modal-inner__lines';
    data.lines.forEach(function(line) {
      lines.appendChild(modalLineRow(card, line));
    });
    var foot = document.createElement('div');
    foot.className = 'start-with-set-modal-inner__footer';
    if (discountPct) {
      var promo = document.createElement('p');
      promo.className = 'start-with-set-modal-inner__promo';
      var promoTpl = (window.lngg && window.lngg.start_with_a_set_discount_unlock) ? window.lngg.start_with_a_set_discount_unlock : 'Add this set and unlock %percentage% off';
      promo.textContent = replacePercentageToken(promoTpl, discountPct);
      foot.appendChild(promo);
    }
    var submit = document.createElement('button');
    submit.type = 'button';
    submit.className = 'btn start-with-set-modal-inner__submit';
    var submitLabel = document.createElement('span');
    submitLabel.className = 'start-with-set-modal-inner__submit-label';
    var submitPrices = document.createElement('span');
    submitPrices.className = 'start-with-set-modal-inner__submit-prices';
    submit.appendChild(submitLabel);
    submit.appendChild(submitPrices);
    foot.appendChild(submit);
    panel.appendChild(head);
    panel.appendChild(lines);
    panel.appendChild(foot);
    grid.appendChild(media);
    grid.appendChild(panel);
    inner.appendChild(grid);
    lines.addEventListener('change', function() {
      updateSubmitLabel(submit, lines, data);
    });
    schedulePickerReady(function() {
      updateSubmitLabel(submit, lines, data);
    });
    submit.addEventListener('click', function() {
      if (submit.disabled) return;
      var bb = document.querySelector('bundle-builder');
      if (!bb || !bb.bundlerApi || typeof bb.bundlerApi.applyStartWithSet !== 'function') {
        var errMsg = (window.lngg && window.lngg.start_with_a_set_no_bundle) ? window.lngg.start_with_a_set_no_bundle : 'Bundle builder not found on this page.';
        window.alert(errMsg);
        return;
      }
      var step = data.bundleStep || 1;
      try {
        var stepsConfig = bb && bb.bundlerApi && bb.bundlerApi.dataJson && bb.bundlerApi.dataJson.products_steps ? bb.bundlerApi.dataJson.products_steps : null;
        if (stepsConfig && stepsConfig.length) {
          var firstRequiredIx = stepsConfig.findIndex(function(s) { return s && s.min_items && Number(s.min_items) > 0; });
          if (firstRequiredIx > -1) step = firstRequiredIx + 1;
        }
      } catch (e) {}
      var parentId = data.parentId;
      var bulk = [];
      lines.querySelectorAll('.start-with-set-modal-line').forEach(function(lineEl) {
        var vid = getModalLineVariantId(lineEl);
        var product = getLineProductJson(lineEl, data);
        if (!product) return;
        if (vid == null && product.variants && product.variants.length) {
          var firstAvailable = product.variants.find(function(v) { return !!v.available; });
          vid = (firstAvailable ? firstAvailable.id : product.variants[0].id) / 1;
        }
        if (vid == null) return;
        var variant = product.variants.find(function(x) { return Number(x.id) === Number(vid); });
        if (!variant) return;
        bulk.push({
          variantId: vid,
          quantity: 1,
          productJson: product,
          title: product.title,
          imageHtml: buildVariantImageHtml(product, variant),
          step: step,
          setOriginProductId: parentId
        });
      });
      bb.bundlerApi.applyStartWithSet(parentId, bulk);
      if (window.$s && window.$s.closeModal) window.$s.closeModal();
    });
    if (window.$s && window.$s.openModal) {
      window.$s.openModal(inner, 'start-with-set-modal', {});
      schedulePickerReady(function() {
        copySwsModalVarsFromSectionToNode(inner, themeRoot);
      });
      return true;
    }
    return false;
  }
  function tryRemoveSetFromBundle(card) {
    var bb = document.querySelector('bundle-builder');
    if (!bb || !bb.bundlerApi || typeof bb.bundlerApi.removeLinesBySetOriginProductId !== 'function') return;
    var parentId = card.dataset.productId;
    bb.bundlerApi.removeLinesBySetOriginProductId(parentId);
    var items = bb.bundlerApi.getItemsAddedSnapshot ? bb.bundlerApi.getItemsAddedSnapshot() : [];
    syncStartWithSetUi(bb, items);
  }
  function syncBundleHeaderAndCards(ev) {
    var bb = ev.target && typeof ev.target.closest === 'function' ? ev.target.closest('bundle-builder') : null;
    if (!bb) return;
    var items = (ev.detail && ev.detail.itemsAdded) ? ev.detail.itemsAdded : [];
    syncStartWithSetUi(bb, items);
  }
  var bundleItemsListenerBound = false;
  function bindBundleItemsListener() {
    if (bundleItemsListenerBound) return;
    bundleItemsListenerBound = true;
    document.addEventListener('bundleBuilderItemsUpdated', syncBundleHeaderAndCards);
  }
  function initSection(root) {
    root.addEventListener('click', function(e) {
      var card = e.target.closest('.start-with-set-card');
      if (!card || !root.contains(card)) return;
      if (card.classList.contains('is-added')) {
        e.preventDefault();
        tryRemoveSetFromBundle(card);
        return;
      }
      var trigger = e.target.closest('.start-with-set-card__trigger');
      if (!trigger) return;
      var script = card.querySelector('script[type="application/json"][data-set-card-json]');
      if (!script) return;
      var data;
      try {
        data = JSON.parse(script.textContent);
      } catch (err) {
        return;
      }
      if (!data.lines || !data.lines.length) return;
      e.preventDefault();
      openModal(root, card, data);
    });
  }
  function openModalForCard(card) {
    if (!card) return false;
    if (card.classList.contains('is-added')) return true;
    var data = getSetCardJson(card);
    if (!data || !data.lines || !data.lines.length) return false;
    var themeRoot = getSwsThemeRoot(card);
    if (!themeRoot) return false;
    return openModal(themeRoot, card, data);
  }
  function openModalForProductId(productId) {
    return openModalForCard(findSetCardByProductId(productId));
  }
  function openModalForHandle(handle) {
    return openModalForCard(findSetCardByHandle(handle));
  }
  function openModalForPreset(preset) {
    if (!preset) return false;
    var card = null;
    if (preset.value) card = findSetCardByPresetValue(preset.value);
    if (!card && preset.setProductId) card = findSetCardByProductId(preset.setProductId);
    if (!card && preset.setHandle) card = findSetCardByHandle(preset.setHandle);
    return openModalForCard(card);
  }
  window.startWithASet = {
    openModalForCard: openModalForCard,
    openModalForHandle: openModalForHandle,
    openModalForProductId: openModalForProductId,
    openModalForPreset: openModalForPreset,
    _booted: true
  };
  function boot() {
    bindBundleItemsListener();
    document.querySelectorAll('[data-start-with-set-section]').forEach(initSection);
    document.dispatchEvent(new CustomEvent('startWithASetReady'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
